import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'

export type TBookableShipmentSavedSearchFilters = Omit<
  BookableShipmentSavedSearch,
  'id' | 'totalResultCount' | 'unviewedResultCount'
>

export const BookableShipmentSavedSearchFiltersKeys: (keyof TBookableShipmentSavedSearchFilters)[] = [
  'pickupCity',
  'pickupStateCode',
  'pickupTimes',
  'pickupMiles',
  'pickupStartDate',
  'pickupEndDate',
  'pickupIsoDaysOfWeek',
  'deliveryCity',
  'deliveryStateCode',
  'deliveryMiles',
  'deliveryStartDate',
  'deliveryEndDate',
  'trailerType',
  'loadedMilesMin',
  'loadedMilesMax',
  'dropTrailer',
]

export type TBookableShipmentSavedSearchModalMode = 'dispatcher_truck_availability' | undefined
